module.exports = __webpack_public_path__ + "img/soporte_interno_mobile.ff05f310.svg";